import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, fmtErr } from "../api";
import BrandMark from "../components/BrandMark";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <div className="mb-8"><BrandMark size={44} dark /></div>
        <h2 className="font-heading text-2xl font-bold text-[#002B5D]">Choose a new password</h2>
        {!token ? (
          <div data-testid="reset-password-no-token" className="mt-6 text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-4 py-3">
            This reset link is missing its token.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="reset-password-form">
            <div>
              <label className="sk-label" htmlFor="rp-pass">New password</label>
              <input id="rp-pass" data-testid="reset-password-input" type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)} className="sk-input" />
            </div>
            <div>
              <label className="sk-label" htmlFor="rp-confirm">Confirm password</label>
              <input id="rp-confirm" data-testid="reset-password-confirm-input" type="password" required minLength={6}
                value={confirm} onChange={(e) => setConfirm(e.target.value)} className="sk-input" />
            </div>
            {error && <div data-testid="reset-password-error" className="text-sm text-rose-600">{error}</div>}
            <button data-testid="reset-password-submit" type="submit" disabled={busy}
              className="w-full h-11 rounded-md font-heading font-bold text-white disabled:opacity-60" style={{ backgroundColor: "#EB1C27" }}>
              {busy ? "Updating..." : "Update Password"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" data-testid="reset-back-to-login" className="text-sm text-[#002B5D] hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
